import React, { useState, useEffect, useRef } from 'react';
// import './FadeInSection.css'; // Optional, if you need additional styles

const FadeInSection = ({ children, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`${className} ${isVisible ? 'visible' : ''}`}>
      {children}
    </div>
  );
};

export default FadeInSection;
